import * as React from 'react';

import { Col, Text } from '@opendoor/bricks-next';
import { getHeaderFooterStaticProps } from 'cms';
import type { HeaderFooterStaticProps } from 'cms';
import type { GetStaticProps } from 'next';
import Head from 'next/head';
import { useRouter } from 'next/router';

import Layout from '../components/landing-pages-v2/Layout';

// Anonymous phone-verification confirmation page, migrated off the legacy
// AngularJS `market` app. The `code`/`exp` query params are read client-side so
// the server-rendered HTML carries no per-user code and stays cacheable.
const VerifyConfirmation: React.FC = () => {
  const router = useRouter();

  if (!router.isReady) {
    return null;
  }

  const confirmationCode = router.query.code;
  const exp = Number(router.query.exp);
  const nowInSeconds = Date.now() / 1000;
  const isExpired = Number.isFinite(exp) && nowInSeconds > exp;

  return (
    <Col width="100%" maxWidth="$150" gap="$6">
      {isExpired ? (
        <Text tag="p" typography="$bodyLarge" textAlign="center">
          Your confirmation code has expired. Please re-submit your information in the Opendoor app.
        </Text>
      ) : (
        <Text tag="p" typography="$bodyLarge" textAlign="center">
          Your confirmation code is{' '}
          <Text tag="span" typography="$bodyLarge" fontWeight="$medium">
            {confirmationCode}
          </Text>
          . Please enter it into the Opendoor app.
        </Text>
      )}
    </Col>
  );
};

const Verify: React.FC<HeaderFooterStaticProps> = ({ header, footer }) => (
  <Layout header={header ?? undefined} footer={footer ?? undefined} slug="/verify">
    <Head>
      <title>Verify Your Phone Number | Opendoor</title>
      <meta name="robots" content="noindex, nofollow" />
    </Head>
    <Col width="100%" alignItems="center" px="$6" py="$32" $largerThanXS={{ px: '$12' }}>
      <VerifyConfirmation />
    </Col>
  </Layout>
);

export const getStaticProps: GetStaticProps<HeaderFooterStaticProps> = getHeaderFooterStaticProps;

export default Verify;
